import {
  PayeeRequirement,
  RequirementStatus
} from "@wingspanhq/wingspan-api-sdk";

import { selectorIsRequirementPostApproval } from "./selectorIsRequirementPostApproval";

export const selectorIsRequirementRejected = (
  requirement: PayeeRequirement
) => {
  const isRequirementIncomplete =
    requirement.status === RequirementStatus.PENDING_COMPLETION;

  return (
    selectorIsRequirementPostApproval(requirement) && isRequirementIncomplete
  );
};
